import React from "react";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import Layout from "../../components/layout";
import * as cuentasContablesActions from "../../actions/cuentasContables";
import * as modalsActions from "../../actions/modals";
import { QueryResponse } from "../../../types/QueryResponse";
import { QueryArguments } from "../../../types-business/QueryArguments";
import CONSTANTS from "../../../utils/constants";
import { CuentaContable } from "../../../types/CuentaContable";
import CuentasContables from "../../components/cuentasContables";

interface Props {
  cuentasContables: QueryResponse<CuentaContable>;
  getCuentasContables: (args?: QueryArguments) => any;
  searching: boolean;
  toggleCreateCuentaContableModal: (cuentaContable) => any;
  reloadCuentasContables: boolean;
  getCatalogoCuentasContables: () => void;
}

const CUENTAS_SEARCH_STATUS = "TODOS";

class CuentasContablesPage extends React.Component<Props> {
  state = {
    filters: {
      size: CONSTANTS.DEFAULT_PAGE_SIZE,
      page: 0,
      estatus: CUENTAS_SEARCH_STATUS
    }
  };

  componentDidMount() {
    this.props.getCatalogoCuentasContables();
  }

  componentDidUpdate() {
    if (this.props.reloadCuentasContables) {
      this.props.getCuentasContables(this.state.filters);
    }
  }

  onFetchData = (pagination?) => {
    const {
      estatus,
      size: currentSize,
      page: currentPage
    } = this.state.filters;
    const size = pagination ? pagination.pageSize : currentSize;
    const page = pagination ? pagination.page : currentPage;

    this.props.getCuentasContables({ size, page, estatus });
    this.setState(state => {
      return {
        ...state,
        filters: {
          size,
          page,
          estatus
        }
      };
    });
  };

  render() {
    return (
      <main>
        <Helmet title="Cuentas Contables" />
        <Layout>
          <CuentasContables
            cuentasContables={this.props.cuentasContables}
            fetchData={this.onFetchData}
            searching={this.props.searching}
            onClickNewCuentaContable={
              this.props.toggleCreateCuentaContableModal
            }
          />
        </Layout>
      </main>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getCuentasContables: (args?: QueryArguments) => {
    dispatch(cuentasContablesActions.getCuentasContables(args));
  },
  toggleCreateCuentaContableModal: cuentaContable => {
    dispatch(modalsActions.toggleCreateCuentaContableModal(cuentaContable));
  },
  getCatalogoCuentasContables: () => {
    dispatch(cuentasContablesActions.getCatalogoCuentasContables());
  }
});

const mapStateToProps = state => {
  const { cuentasContables } = state;
  return {
    cuentasContables: cuentasContables.cuentasContables || {
      data: [],
      totalPages: 0
    },
    searching: cuentasContables.gettingCuentasContables,
    reloadCuentasContables: cuentasContables.reloadCuentasContables
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CuentasContablesPage);
